(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CoutAchatEauDialogController', CoutAchatEauDialogController);

    CoutAchatEauDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'CoutAchatEau'];

    function CoutAchatEauDialogController ($scope, $stateParams, $uibModalInstance, entity, CoutAchatEau) {
        var vm = this;
        vm.coutAchatEau = entity;
        vm.load = function(id) {
            CoutAchatEau.get({id : id}, function(result) {
                vm.coutAchatEau = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:coutAchatEauUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.coutAchatEau.id !== null) {
                CoutAchatEau.update(vm.coutAchatEau, onSaveSuccess, onSaveError);
            } else {
                CoutAchatEau.save(vm.coutAchatEau, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateAjout = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
